var timeSpent = function(seconds){
    return new Promise(function(resolve, reject){
        setTimeout(function(){
            resolve(seconds);
        }, seconds * 1000);
    });
}

export default timeSpent;


//////////////////
// WEBPACK FOOTER
// ./src/strategies/time-spent.js
// module id = 8
// module chunks = 0